import { easing } from '../helpers';

import App from '../app';


class AudioController {

	constructor() {
		this.audio = {};

		this.fade = {};

		// this.audio = null;
		// this.context = null;
		// this.source = null;
		// this.analyser = null;
		// this.array = null;
	}

	add(id, mp4) {
		if (this.audio[id]) this.remove(id);
		this.audio[id] = new Audio(mp4);
		this.audio[id].volume = 0;
		return this.audio[id];
	}

	remove(id) {
		this.pause(id);
		delete this.audio[id];
	}

	reference(id) {
		return this.audio[id];
	}

	play(id) {
		return new Promise((resolve) => {
			this.audio[id].play()
				.then(resolve)
				.catch(() => {
					// console.log(e);
				});
		});
	}

	pause(id) {
		this.audio[id].pause();
	}

	toggle(id) {
		this.audio[id].paused ? this.play(id) : this.pause(id);
	}

	volume(id, volume) {
		return new Promise((resolve) => {
			if (App.touch) {
				if (volume === 1) {
					this.audio[id].volume = 1;
					this.audio[id].play();
				} else {
					this.audio[id].volume = 0;
					this.audio[id].pause();
				}
			} else {
				const max = Math.max(this.audio[id].volume, volume);
				const min = Math.min(this.audio[id].volume, volume);

				const direction = volume > this.audio[id].volume ? 1 : -1;

				let frame = 0;
				if (this.fade[id]) clearInterval(this.fade[id]);
				this.fade[id] = setInterval(() => {
					if (frame++ < 15) {
						const ease = easing.easeOutCubic(frame, 0, max - min, 15);
						this.audio[id].volume = direction > 0 ? min + ease : max - ease;
					} else {
						clearInterval(this.fade[id]);
						resolve();
					}
				}, 1000 / 30);
			}
		});
	}

	on(id, event, fn) {
		this.audio[id].addEventListener(event, fn);
	}

	off(id, event, fn) {
		this.audio[id].removeEventListener(event, fn);
	}

	// createAudio() {
	// 	this.audio = document.createElement('audio');
	// 	this.audio.crossOrigin = 'anonymous';
	// 	this.audio.volume = 0;
	// 	this.context = AudioController.getContext('quote');
	// 	this.analyser = this.context.createAnalyser();
	// 	this.analyser.connect(this.context.destination);
	// 	this.analyser.fftSize = 32;
	// 	this.array = new Uint8Array(this.analyser.frequencyBinCount);
	// }

	// createSource() {
	// 	this.source = this.context.createMediaElementSource(this.audio);
	// 	this.source.connect(this.analyser);
	// }

	// play() {
	// 	if (this.ended) {
	// 		this.ended = false;
	// 		this.reset();
	// 	}
	// 	this.audio.play()
	// 		.then(() => this.fadeVolume(1))
	// 		.catch(() => {
	// 			// console.warn(e);
	// 		});
	// }

	// pause() {
	// 	this.fadeVolume(0).then(() => this.audio.pause());
	// }

	// startInterval() {
	// 	this.interval = setInterval(() => {
	// 		this.analyser.getByteFrequencyData(this.array);
	// 		const data = this.array;
	// 		const canvas = document.querySelector('.cursor-takeover canvas');
	// 		const context = canvas.getContext('2d');
	//
	// 		const spans = document.querySelectorAll('.cursor-takeover__icon--audio-visualizer span');
	// 		for (let i = 0; i < 8; ++i) {
	// 			const p = (data[i * 2] + data[i * 2 + 1]) / 2 / 255;
	// 			spans[i].style.transform = `translate(-50%, -50%) skew(-45deg) scale(${p})`;
	// 			spans[i].style.opacity = p * 0.75;
	// 		}
	// 	}, 1000 / 30);
	// }

	// stopInterval() {
	// 	clearInterval(this.interval);
	// 	this.interval = null;
	// }

}

export default new AudioController();
